import {SET_ALL_REQUEST_CHECKBOX_VALUE} from "../../enums/Employees/employees.types";

export const setAllRequestCheckBoxAction = (value) => {
    return {
        type: SET_ALL_REQUEST_CHECKBOX_VALUE,
        payload: value,
    };
};
